export const OWN_PROFILE_ADMIN_ONLY = true
